// extracted by mini-css-extract-plugin
module.exports = {"loan-slider":"LoanModifier_loan-slider__GzWel","slider":"LoanModifier_slider__S9iUR","text-right":"LoanModifier_text-right__OYebg"};